<div class="view-toggle-container">
  <mat-button-toggle-group [(ngModel)]="currentView" aria-label="Stats Type">
    <mat-button-toggle value="engagement">Engagement</mat-button-toggle>
    <mat-button-toggle value="music">Music</mat-button-toggle>

    <mat-button-toggle value="video">Video</mat-button-toggle>

    <mat-button-toggle value="concerts">Concerts</mat-button-toggle>
    <mat-button-toggle value="memberships">Memberships</mat-button-toggle>
    <mat-button-toggle value="profile">Profile</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="outer" *ngIf="currentView === 'music'">
  <!-- Titling row -->
  <div class="titling-row">
    <span class="title-empty-space">Releases</span>
    <span class="title-play-count">Plays</span>
    <span *ngIf="hasFullAnalyticsAccess" class="title-unique-listeners"
      >Listeners</span
    >
  </div>

  <!-- Albums list -->
  <div *ngFor="let album of albums" class="album-container">
    <hr />
    <div class="album-header">
      <!-- Display album art -->
      <img class="album-art" [src]="album.art" [alt]="album.name + ' cover'" />
      <!-- Album title and release date -->
      <div class="album-info">
        <div
          *ngIf="!album.editing"
          class="album-title"
          title="{{ album.name }}"
        >
          {{
            album.name.length > 50
              ? (album.name | slice : 0 : 50) + "..."
              : album.name
          }}
        </div>
        <div *ngIf="!album.editing" class="release-date">
          {{ album.released | date : "MMM d, y" }}
        </div>
        <div *ngIf="album.editing">
          <input [(ngModel)]="album.name" placeholder="Album Name" />
          <input
            [(ngModel)]="album.released"
            placeholder="Release Date"
            type="date"
          />
          <div class="membership-section">
            <input
              type="number"
              [(ngModel)]="album.price"
              placeholder="Price (e.g., 9.99)"
            />
            <mat-slide-toggle [(ngModel)]="album.membersOnly"
              >Members Only</mat-slide-toggle
            >
            <div *ngIf="album.membersOnly">
              <label>Required Membership:</label>
              <select
                [(ngModel)]="album.tier"
                (ngModelChange)="onVideoTierChange(album, $event)"
              >
                <option value="" disabled>Select a tier</option>
                <option
                  *ngFor="let member of currentUser?.memberships"
                  [value]="member.tier"
                >
                  {{ member.tier }} ({{ member.level }}) - ${{ member.price }}
                </option>
              </select>
              <p *ngIf="album.level" class="help-text">
                Selected Level: {{ album.level }}
              </p>
            </div>
          </div>
          <button (click)="saveEdit(album)">Save</button>
          <button (click)="cancelEdit(album)">Cancel</button>
        </div>
        <mat-slide-toggle
          style="margin-right: 1rem"
          [(ngModel)]="album.showing"
          (change)="toggleMode($event, album)"
          class="example-margin"
        >
          {{ album.mode }}
        </mat-slide-toggle>
        <div>
          <button *ngIf="!album.editing" (click)="album.editing = true">
            Edit Album
          </button>
          <button *ngIf="album.editing" (click)="cancelEdit(album)">
            Cancel Edit
          </button>
          <button (click)="deleteAlbum(album.id)">Delete Release</button>

          <button (click)="copyShareLink(album)">Share</button>
        </div>
      </div>
    </div>

    <ul class="track-list">
      <!-- Iterate over tracks within an album, adding index to the track title -->
      <li *ngFor="let track of album.tracks; let i = index" class="track-item">
        <!-- Display index and track name -->
        <!-- <span class="track-index"></span> -->
        <span
          *ngIf="!track.editing"
          (click)="openSong(album.art, track, album)"
          class="track-name"
          title="{{ track.title }}"
          >{{ i + 1 }}.
          {{
            track.title.length > 50
              ? (track.title | slice : 0 : 50) + "..."
              : track.title
          }}</span
        >
        <!-- Display count of plays for the track -->
        <span
          (click)="openSong(album.art, track, album)"
          *ngIf="!album.editing"
          class="play-count"
          >{{ track.playCount !== undefined ? track.playCount : "0" }}</span
        >
        <!-- Display count of unique listeners for the track -->
        <span
          (click)="openSong(album.art, track, album)"
          *ngIf="!album.editing && hasFullAnalyticsAccess"
          class="unique-listeners"
          >{{
            track.uniqueListenerCount !== undefined
              ? track.uniqueListenerCount
              : "0"
          }}</span
        >
        <button
          *ngIf="!track.editing && album.editing"
          (click)="editTrack(album, track)"
        >
          Edit Track
        </button>

        <div *ngIf="track.editing">
          <input [(ngModel)]="track.title" placeholder="Track Title" />
          <div class="membership-section">
            <input
              type="number"
              [(ngModel)]="track.price"
              placeholder="Price (e.g., 1.29)"
            />
            <mat-slide-toggle [(ngModel)]="track.membersOnly"
              >Members Only</mat-slide-toggle
            >
            <div *ngIf="track.membersOnly">
              <label>Required Membership:</label>
              <select
                [(ngModel)]="track.tier"
                (ngModelChange)="onVideoTierChange(track, $event)"
              >
                <option value="" disabled>Select a tier</option>
                <option
                  *ngFor="let member of currentUser?.memberships"
                  [value]="member.tier"
                >
                  {{ member.tier }} ({{ member.level }}) - ${{ member.price }}
                </option>
              </select>
              <p *ngIf="track.level" class="help-text">
                Selected Level: {{ track.level }}
              </p>
            </div>
          </div>
          <button (click)="saveEditTrack(album, i, track)">Save</button>
          <button (click)="cancelEditTrack(track)">Cancel</button>
          <!-- Audio file input -->
          <input
            type="file"
            (change)="onFileSelected($event, i)"
            accept=".m4a"
          />

          <!-- Progress bar -->
          <div *ngIf="upload">
            <mat-progress-bar
              mode="determinate"
              [value]="upload"
            ></mat-progress-bar>
            <p>{{ upload | number : "1.0-0" }}%</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="outer" *ngIf="currentView === 'video'">
  <!-- Titling row -->
  <div class="titling-row">
    <span class="title-empty-space">Videos</span>
    <span class="title-play-count">Views</span>
    <span *ngIf="hasFullAnalyticsAccess" class="title-unique-listeners"
      >Unique Viewers</span
    >
  </div>

  <!-- Videos list -->
  <div *ngFor="let video of videos" class="album-container">
    <hr />
    <!-- A new, dedicated structure for video rows to ensure proper column alignment -->
    <div class="video-entry">
      <div class="video-details">
        <!-- Display video thumbnail -->
        <img
          class="album-art"
          [src]="video.thumbnail"
          [alt]="video.title + ' thumbnail'"
        />
        <!-- Video info -->
        <div class="album-info">
          <div
            *ngIf="!video.editing"
            class="album-title"
            title="{{ video.title }}"
          >
            {{
              video.title.length > 50
                ? (video.title | slice : 0 : 50) + "..."
                : video.title
            }}
          </div>
          <div *ngIf="!video.editing" class="release-date">
            {{ video.releaseDate | date : "MMM d, y" }}
          </div>
          <div
            *ngIf="!video.editing && video.type"
            class="release-date"
            style="font-style: italic; font-size: 0.9em"
          >
            {{ video.type }}
          </div>
          <div *ngIf="video.editing">
            <input [(ngModel)]="video.title" placeholder="Video Title" />
            <textarea
              [(ngModel)]="video.description"
              placeholder="Description"
            ></textarea>
            <select [(ngModel)]="video.type">
              <option value="Music Video">Music Video</option>
              <option value="Podcast">Podcast</option>
              <option value="Interview">Interview</option>
              <option value="Behind the Scenes">Behind the Scenes</option>
              <option value="Live Performance">Live Performance</option>
            </select>
            <div class="membership-section">
              <input
                type="number"
                [(ngModel)]="video.price"
                placeholder="Price (e.g., 2.99)"
              />
              <mat-slide-toggle [(ngModel)]="video.membersOnly"
                >Members Only</mat-slide-toggle
              >
              <div *ngIf="video.membersOnly">
                <label>Required Membership:</label>
                <select
                  [(ngModel)]="video.tier"
                  (ngModelChange)="onVideoTierChange(video, $event)"
                >
                  <option value="" disabled>Select a tier</option>
                  <option
                    *ngFor="let member of currentUser?.memberships"
                    [value]="member.tier"
                  >
                    {{ member?.tier }} ({{ member?.level }}) - ${{
                      member?.price
                    }}
                  </option>
                </select>
                <p *ngIf="video.level" class="help-text">
                  Selected Level: {{ video.level }}
                </p>
              </div>
            </div>
            <input
              [(ngModel)]="video.releaseDate"
              placeholder="Release Date"
              type="date"
            />
            <input
              [(ngModel)]="video.dspDate"
              placeholder="DSP Release Date"
              type="date"
            />
            <button (click)="saveVideoEdit(video)">Save</button>
            <button (click)="cancelEdit(video)">Cancel</button>
          </div>
          <mat-slide-toggle
            style="margin-right: 1rem"
            [(ngModel)]="video.showing"
            (change)="toggleVideoMode($event, video)"
            class="example-margin"
          >
            {{ video.mode }}
          </mat-slide-toggle>
          <div>
            <button *ngIf="!video.editing" (click)="video.editing = true">
              Edit Video
            </button>
            <button *ngIf="video.editing" (click)="cancelEdit(video)">
              Cancel Edit
            </button>
            <button (click)="deleteVideo(video.id)">Delete Video</button>
          </div>
        </div>
      </div>
      <div class="stat-column play-count">
        {{ video.viewCount || 0 }}
      </div>
      <div *ngIf="hasFullAnalyticsAccess" class="stat-column unique-listeners">
        {{ video.uniqueViewerCount || 0 }}
      </div>
    </div>
  </div>
</div>

<div class="outer" *ngIf="currentView === 'profile'">
  <div class="concert-form-container">
    <h2>Edit Your Profile</h2>
    <p>This information will be visible to fans on your public artist page.</p>

    <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
      <!-- Profile Images -->
      <h3>Profile Images</h3>
      <div class="profile-images-container">
        <!-- Avatar Upload -->
        <div class="image-upload-control">
          <label>Avatar</label>
          <img
            [src]="
              avatarPreviewUrl ||
              currentUser?.avatarUrl ||
              'assets/img/default-avatar.png'
            "
            alt="Avatar Preview"
            class="avatar-preview"
          />
          <input
            type="file"
            (change)="onAvatarSelected($event)"
            accept="image/*jpeg"
            #avatarUpload
            hidden
          />
          <button type="button" (click)="avatarUpload.click()">
            Choose Image
          </button>
          <mat-progress-bar
            *ngIf="avatarUploadProgress !== null"
            mode="determinate"
            [value]="avatarUploadProgress"
          ></mat-progress-bar>
        </div>

        <!-- Banner Upload -->
        <div class="image-upload-control">
          <label>Banner</label>
          <img
            [src]="
              bannerPreviewUrl ||
              currentUser?.bannerPhoto ||
              'assets/img/default-banner.png'
            "
            alt="Banner Preview"
            class="banner-preview"
          />
          <input
            type="file"
            (change)="onBannerSelected($event)"
            accept="image/jpeg"
            #bannerUpload
            hidden
          />
          <button type="button" (click)="bannerUpload.click()">
            Choose Image
          </button>
          <mat-progress-bar
            *ngIf="bannerUploadProgress !== null"
            mode="determinate"
            [value]="bannerUploadProgress"
          ></mat-progress-bar>
        </div>
      </div>

      <!-- Vanity URL Display -->
      <div class="vanity-url-container">
        <label>Your Public URL</label>
        <div class="input-with-button">
          <input readonly [value]="vanityUrl" />
          <button type="button" (click)="copyVanityUrl()">Copy</button>
        </div>
      </div>

      <!-- Handle Editing -->
      <div *ngIf="canEditHandle">
        <label for="handle">Custom Handle (@)</label>
        <input id="handle" formControlName="handle" placeholder="your-handle" />
        <p class="help-text">
          Customize your URL. No spaces or special characters.
        </p>
        <p *ngIf="handleExistsError" class="error-text">
          This handle is already taken. Please choose another.
        </p>
      </div>

      <!-- Short Bio -->
      <label for="shortBio">Short Bio</label>
      <textarea
        id="shortBio"
        formControlName="shortBio"
        rows="4"
        placeholder="Tell your fans a little about yourself."
      ></textarea>

      <!-- Featured Video -->
      <label for="featuredVideo">Featured Video</label>
      <select id="featuredVideo" formControlName="featuredVideo">
        <option value="">-- None --</option>
        <option *ngFor="let video of videos" [value]="video.id">
          {{ video.title }}
        </option>
      </select>

      <!-- Social Links -->
      <h3>Social Links</h3>
      <div formGroupName="socialLinks" class="social-links-group">
        <input formControlName="spotify" placeholder="Spotify URL" />
        <input formControlName="appleMusic" placeholder="Apple Music URL" />
        <input formControlName="youtube" placeholder="YouTube Channel URL" />
      </div>

      <!-- Extra Links -->
      <h3>Extra Links</h3>
      <div formArrayName="extraLinks">
        <div
          *ngFor="let link of extraLinks.controls; let i = index"
          [formGroupName]="i"
          class="extra-link-item"
        >
          <input formControlName="title" placeholder="Link Title" />
          <input formControlName="url" placeholder="https://example.com" />
          <button type="button" (click)="removeExtraLink(i)">Remove</button>
        </div>
      </div>
      <button type="button" (click)="addExtraLink()">Add Extra Link</button>

      <!-- Fan Club -->
      <label for="fanClub">Fan Club Link</label>
      <input
        id="fanClub"
        formControlName="fanClub"
        placeholder="e.g., Discord, Patreon, etc."
      />

      <!-- Form Actions -->
      <div class="form-actions">
        <button type="submit" [disabled]="profileForm.invalid">
          Save Profile
        </button>
      </div>
    </form>
  </div>
</div>

<div class="outer" *ngIf="currentView === 'memberships'">
  <div *ngIf="!showMembershipForm">
    <button
      class="add-concert-btn"
      (click)="openMembershipForm()"
      [disabled]="currentUser?.memberships?.length >= 3"
    >
      Add New Membership
    </button>

    <div class="concert-list-section">
      <h2>Membership Tiers</h2>
      <div *ngIf="currentUser?.memberships?.length > 0; else noMemberships">
        <div
          *ngFor="let membership of currentUser.memberships; let i = index"
          class="concert-item"
        >
          <div class="concert-info">
            <h3>{{ membership.tier }} - ${{ membership.price }}/month</h3>
            <p>{{ membership.description }}</p>
            <p><strong>Level:</strong> {{ membership.level }}</p>
            <p *ngIf="membership.popular">
              <strong style="color: #ff4081">Popular Tier</strong>
            </p>
          </div>
          <div class="concert-actions">
            <button (click)="openMembershipForm(membership, i)">Edit</button>
            <button (click)="deleteMembership(i)">Delete</button>
          </div>
        </div>
      </div>
      <ng-template #noMemberships
        ><p class="no-data-message">
          No membership tiers created yet.
        </p></ng-template
      >
    </div>
  </div>

  <div *ngIf="showMembershipForm" class="concert-form-container">
    <h2>
      {{ isEditingMembership ? "Edit Membership" : "Add New Membership" }}
    </h2>
    <form [formGroup]="membershipForm" (ngSubmit)="saveMembership()">
      <input formControlName="tier" placeholder="Tier Name (e.g., Gold)" />
      <input
        formControlName="price"
        type="number"
        placeholder="Monthly Price"
      />
      <textarea
        formControlName="description"
        placeholder="Description"
      ></textarea>
      <input formControlName="level" placeholder="Level" />
      <mat-slide-toggle formControlName="popular"
        >Mark as Popular</mat-slide-toggle
      >

      <h3>Features</h3>
      <div formArrayName="features">
        <div
          *ngFor="let feature of features.controls; let i = index"
          class="feature-item"
        >
          <input [formControlName]="i" placeholder="Feature description" />
          <button type="button" (click)="removeFeature(i)">Remove</button>
        </div>
      </div>
      <button type="button" (click)="addFeature()">Add Feature</button>

      <div class="form-actions">
        <button type="submit" [disabled]="membershipForm.invalid">
          Save Membership
        </button>
        <button type="button" (click)="cancelMembershipEdit()">Cancel</button>
      </div>
    </form>
  </div>
</div>

<div class="outer" *ngIf="currentView === 'concerts'">
  <div *ngIf="!showConcertForm">
    <button class="add-concert-btn" (click)="openConcertForm()">
      Add New Concert
    </button>

    <div class="concert-list-section">
      <h2>Upcoming Concerts</h2>
      <div *ngIf="upcomingConcerts.length > 0; else noUpcoming">
        <div *ngFor="let concert of upcomingConcerts" class="concert-item">
          <div class="concert-info">
            <p>
              {{ concert.date | date : "fullDate" }} at
              {{ concert.date | date : "shortTime" }}
            </p>
            <h3>{{ concert.venue }}</h3>
            <p>{{ concert.city }}, {{ concert.country }}</p>
          </div>
          <div class="concert-actions">
            <button (click)="openConcertForm(concert)">Edit</button>
            <button (click)="deleteConcert(concert.id)">Delete</button>
          </div>
        </div>
      </div>
      <ng-template #noUpcoming
        ><p class="no-data-message">
          No upcoming concerts scheduled.
        </p></ng-template
      >
    </div>

    <div class="concert-list-section">
      <h2>Past Concerts</h2>
      <div *ngIf="pastConcerts.length > 0; else noPast">
        <div *ngFor="let concert of pastConcerts" class="concert-item">
          <div class="concert-info">
            <p>{{ concert.date | date : "fullDate" }}</p>
            <h3>{{ concert.venue }}</h3>
            <p>{{ concert.city }}, {{ concert.country }}</p>
          </div>
          <div class="concert-actions">
            <button (click)="openConcertForm(concert)">View/Edit</button>
            <button (click)="deleteConcert(concert.id)">Delete</button>
          </div>
        </div>
      </div>
      <ng-template #noPast
        ><p class="no-data-message">No past concerts found.</p></ng-template
      >
    </div>
  </div>

  <div *ngIf="showConcertForm" class="concert-form-container">
    <h2>{{ isEditingConcert ? "Edit Concert" : "Add New Concert" }}</h2>
    <div *ngIf="!canSetConcertPrice" class="upgrade-prompt-inline">
      <p>
        Your account type does not allow charging for tickets. You can still
        create free events.
      </p>
      <button (click)="navigateToUpgrade()">
        Upgrade to Add Ticket Prices
      </button>
    </div>

    <form [formGroup]="concertForm" (ngSubmit)="saveConcert()">
      <label for="venue">Venue Name</label>
      <input id="venue" formControlName="venue" placeholder="Venue Name" />

      <label for="city">City</label>
      <input id="city" formControlName="city" placeholder="City" />

      <label for="country">Country</label>
      <input id="country" formControlName="country" placeholder="Country" />

      <label for="date">Date & Time</label>
      <input id="date" formControlName="date" type="datetime-local" />

      <label for="capacity">Capacity</label>
      <input
        id="capacity"
        formControlName="capacity"
        type="number"
        placeholder="Capacity"
      />

      <label for="status">Status</label>
      <select id="status" formControlName="status">
        <option value="on-sale">On Sale</option>
        <option value="sold-out">Sold Out</option>
        <option value="postponed">Postponed</option>
        <option value="cancelled">Cancelled</option>
      </select>

      <h3>Ticket Types</h3>
      <div formArrayName="ticketTypes">
        <div
          *ngFor="let ticket of ticketTypes.controls; let i = index"
          [formGroupName]="i"
          class="ticket-type-group"
        >
          <label for="ticket-name-{{ i }}">Ticket Name</label>
          <input
            id="ticket-name-{{ i }}"
            formControlName="name"
            placeholder="e.g., General Admission"
          />

          <label for="ticket-price-{{ i }}">Price</label>
          <input
            id="ticket-price-{{ i }}"
            formControlName="price"
            type="text"
            placeholder="e.g., 25.00"
          />

          <label for="ticket-description-{{ i }}">Description</label>
          <textarea
            id="ticket-description-{{ i }}"
            formControlName="description"
            placeholder="Description"
          ></textarea>
          <button type="button" (click)="removeTicketType(i)">Remove</button>
        </div>
      </div>
      <button type="button" (click)="addTicketType()">Add Ticket Type</button>

      <div class="form-actions">
        <button type="submit" [disabled]="concertForm.invalid">
          Save Concert
        </button>
        <button type="button" (click)="cancelConcertEdit()">Cancel</button>
      </div>
    </form>
  </div>
</div>

<div class="outer" *ngIf="currentView === 'engagement'">
  <div class="charts-container">
    <div class="chart-wrapper line-chart-wrapper">
      <h2>Subscriber Growth</h2>
      <ngx-charts-line-chart
        *ngIf="subscriberFollowerData?.length > 0; else noSubscribers"
        [results]="subscriberFollowerData"
        [scheme]="'vivid'"
        [gradient]="false"
        [view]="[550, 250]"
        [legend]="false"
        [xAxis]="true"
        [yAxis]="true"
        [autoScale]="true"
        [grid]="false"
        [showGridLines]="false"
      >
      </ngx-charts-line-chart>

      <ng-template #noSubscribers>
        <div class="no-data-message engagement-placeholder">
          <p>No engagement data yet.</p>
          <p>Share your oneLink to grow your audience!</p>
        </div>
      </ng-template>
    </div>
    <div class="chart-wrapper">
      <h2>Revenue Breakdown</h2>
      <ngx-charts-pie-chart
        *ngIf="revenueBreakdownData?.length > 0; else noRevenue"
        [results]="revenueBreakdownData"
        [gradient]="true"
        [view]="[220, 220]"
        [labels]="false"
        [doughnut]="false"
        [valueFormatting]="dollarValueFormat"
      >
      </ngx-charts-pie-chart>
      <ng-template #noRevenue>
        <div class="no-data-message engagement-placeholder">
          <p>No revenue in the last 30 days.</p>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="top-items-container">
    <!-- Top Songs List -->
    <div class="top-list">
      <h3>Top 5 Songs (Last 30 Days)</h3>
      <ul *ngIf="topSongs?.length > 0; else noSongs">
        <li *ngFor="let song of topSongs; let i = index" class="top-item">
          <span class="item-rank">{{ i + 1 }}</span>
          <img [src]="song.albumArt" class="item-art" alt="Album art" />
          <span class="item-title">{{ song.title }}</span>
          <span class="item-count">{{ song.plays }} plays</span>
        </li>
      </ul>
      <ng-template #noSongs>
        <p class="no-data-message">No song data for the last 30 days.</p>
      </ng-template>
    </div>

    <!-- Top Videos List -->
    <div class="top-list">
      <h3>Top 5 Videos (Last 30 Days)</h3>
      <ul *ngIf="topVideos?.length > 0; else noVideos">
        <li *ngFor="let video of topVideos; let i = index" class="top-item">
          <span class="item-rank">{{ i + 1 }}</span>
          <img [src]="video.thumbnail" class="item-art" alt="Video thumbnail" />
          <span class="item-title">{{ video.title }}</span>
          <span class="item-count">{{ video.views }} views</span>
        </li>
      </ul>
      <ng-template #noVideos>
        <p class="no-data-message">No video data for the last 30 days.</p>
      </ng-template>
    </div>
  </div>
</div>
